import React, { type ComponentType } from 'react';
import {
  ArrowRight, Shield, Wrench, GitBranch, AlignLeft, Recycle, Share2, CalendarX, Play, CirclePlay, CirclePlus, UserPlus, ShieldCheck, Table2, TrendingUp, CloudOff, MailOpen, Palette, MessageSquare, MessageCircle, Globe, Zap, Puzzle, CirclePause, Inbox, ListOrdered, HeartPulse,
  ArrowLeft, Book, PackageOpen, Briefcase, Building2, BarChart3, LineChart,
  Database, ExternalLink, ReceiptText, Folder, Pen, Receipt, ShoppingBasket,
  ShoppingCart, Wallet, Plus, Settings, Trash2, Pencil, Download, Upload,
  Search, ListFilter, Check, X, Eye, EyeOff, Save, Printer, User, Users, Bell,
  Mail, Lock, Menu, ChevronDown, ChevronLeft, ChevronRight, EllipsisVertical,
  List, File, FileText, Calendar, Clock, Tag, Tags, FolderOpen, Package, ClipboardCheck,
  DollarSign, CreditCard, Percent, Calculator, Store, Truck, Power, LogOut,
  LogIn, RefreshCw, Loader2, Info, Boxes, StickyNote, Paperclip,
  UserShield, Contact, UserCog, Plane,
  UserCheck, MessagesSquare,
  Scale, ChartPie, University, ShoppingBag, Star, Crown,
  Key, Archive, Banknote,
  Monitor, MapPin, Server,
  FileUp, FileDown, Stethoscope, AlignJustify,
  Shuffle, Network, SquarePen, Home,
  Maximize, Minimize, RotateCcw, Image, IdCard,
  SlidersHorizontal, HandCoins, Umbrella, Gift, CheckCheck, FlaskConical,
  Undo2, Layers, CircleMinus, History, TriangleAlert, CircleCheck
} from 'lucide-react';

type IconComponent = ComponentType<{ size?: number | string; className?: string }>;

const REGISTRY: Record<string, IconComponent> = {
  'shield-alt': Shield,
  'shield': Shield,
  'shield-check': ShieldCheck,
  'tools': Wrench,
  'code-branch': GitBranch,
  'align-left': AlignLeft,
  'recycle': Recycle,
  'share-alt': Share2,
  'file-import': FileUp,
  'calendar-times': CalendarX,
  'arrow-right': ArrowRight,
  'forward': ArrowRight,
  'redo': RefreshCw,
  'scale': Scale,
  'play': Play,
  'landmark': University,
  'list-ol': ListOrdered,
  'bar-chart': BarChart3,
  'trending-up': TrendingUp,
  'badge-dollar': HandCoins,
  'play-circle': CirclePlay,
  'receipt-text': ReceiptText,
  'plus-circle': CirclePlus,
  'money-bill': Banknote,
  'times-2': X,
  'tag-2': Tag,
  'edit-2': Pencil,
  'x': X,
  'house': Home,
  'user-plus': UserPlus,
  'table-cells': Table2,
  'arrow-trend-up': TrendingUp,
  'money-check-dollar': Banknote,
  'cloud-off': CloudOff,
  'envelope-open-text': MailOpen,
  'palette': Palette,
  'mail': Mail,
  'message-square': MessageSquare,
  'message-circle': MessageCircle,
  'package': Package,
  'triangle-alert': TriangleAlert,
  'paint-brush': Palette,
  'globe': Globe,
  'cloud-upload-alt': Upload,
  'bolt': Zap,
  'puzzle-piece': Puzzle,
  'pause-circle': CirclePause,
  'calendar-day': Calendar,
  'calendar-week': Calendar,
  'user-clock': Clock,
  'inbox': Inbox,
  'file-invoice': ReceiptText,
  'heartbeat': HeartPulse,

  'id-card': IdCard,
  'image': Image,
  'arrow-left': ArrowLeft,
  'book': Book,
  'box-open': PackageOpen,
  'briefcase': Briefcase,
  'building': Building2,
  'chart-bar': BarChart3,
  'chart-line': LineChart,
  'database': Database,
  'external-link-alt': ExternalLink,
  'file-invoice-dollar': ReceiptText,
  'folder': Folder,
  'folder-open': FolderOpen,
  'pen': Pen,
  'pen-2': Pen,
  'receipt': Receipt,
  'shopping-basket': ShoppingBasket,
  'shopping-cart': ShoppingCart,
  'wallet': Wallet,
  'plus': Plus,
  'cog': Settings,
  'cogs': Settings,
  'settings': Settings,
  'trash': Trash2,
  'trash-alt': Trash2,
  'pencil': Pencil,
  'edit': Pencil,
  'pencil-alt': Pencil,
  'download': Download,
  'upload': Upload,
  'search': Search,
  'filter': ListFilter,
  'check': Check,
  'times': X,
  'eye': Eye,
  'eye-slash': EyeOff,
  'save': Save,
  'print': Printer,
  'user': User,
  'users': Users,
  'bell': Bell,
  'envelope': Mail,
  'lock': Lock,
  'bars': Menu,
  'caret-down': ChevronDown,
  'chevron-down': ChevronDown,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'ellipsis-v': EllipsisVertical,
  'list': List,
  'file': File,
  'file-alt': FileText,
  'file-pdf': FileText,
  'calendar': Calendar,
  'calendar-alt': Calendar,
  'clock': Clock,
  'tag': Tag,
  'tags': Tags,
  'dollar-sign': DollarSign,
  'credit-card': CreditCard,
  'percent': Percent,
  'percentage': Percent,
  'calculator': Calculator,
  'store': Store,
  'truck': Truck,
  'power-off': Power,
  'sign-out-alt': LogOut,
  'sign-in-alt': LogIn,
  'sync': RefreshCw,
  'sync-alt': RefreshCw,
  'spinner': Loader2,
  'circle-notch': Loader2,
  'box': Package,
  'clipboard-check': ClipboardCheck,
  'info': Info,
  'info-circle': Info,
  'check-circle': CircleCheck,
  'boxes': Boxes,
  'sticky-note': StickyNote,
  'paperclip': Paperclip,
  'user-shield': UserShield,
  'user-check': UserCheck,
  'comments': MessagesSquare,
  'address-book': Contact,
  'user-tie': UserCog,
  'plane': Plane,
  'balance-scale': Scale,
  'cart-plus': ShoppingCart,
  'chart-pie': ChartPie,
  'cart-flatbed': Truck,
  'university': University,
  'shopping-bag': ShoppingBag,
  'star': Star,
  'crown': Crown,
  'key': Key,
  'box-archive': Archive,
  'money-bill-wave': Banknote,
  'money-check-alt': Banknote,
  'monitor': Monitor,
  'map-pin': MapPin,
  'server': Server,
  'file-upload': FileUp,
  'file-download': FileDown,
  'stethoscope': Stethoscope,
  'align-justify': AlignJustify,
  'random': Shuffle,
  'project-diagram': Network,
  'file-text': FileText,
  'pen-square': SquarePen,
  'home': Home,
  'cash-register': Calculator,
  'expand-alt': Maximize,
  'compress-alt': Minimize,
  'rotate-ccw': RotateCcw,
  'sliders-h': SlidersHorizontal,
  'hand-holding-usd': HandCoins,
  'business-time': Clock,
  'umbrella-beach': Umbrella,
  'gift': Gift,
  'check-double': CheckCheck,
  'flask': FlaskConical,
  'undo': Undo2,
  'layer-group': Layers,
  'minus-circle': CircleMinus,
  'sitemap': Network,
  'history': History,
  'exclamation-triangle': TriangleAlert,
};

export function iconFor(key?: string, size = 16, className?: string): React.ReactNode {
  if (!key) return null;
  // Normalise defensively: 'fas fa-user', 'fa-user', 'FA-user' and '  fa-user  '
  // must all resolve to the registry's 'user' entry (the old regex stripped a
  // single leading style prefix and did not trim).
  // Order matters: dropping the bare `fa` token leaves a leading space, so the
  // dash strip below is a no-op unless the whitespace is trimmed first —
  // otherwise 'fas fa-save' resolved to '-save' and every icon silently
  // vanished with a spurious "[iconRegistry] unknown icon key" warning.
  const normalizedKey = key
    .trim()
    .toLowerCase()
    .replace(/\b(fas|far|fal|fab|fa)\b/g, '')
    .trim()
    .replace(/^-+|-+$/g, '')
    .replace(/^fa-/, '')
    .trim();
  const Icon = REGISTRY[normalizedKey];
  if (!Icon) {
    if (import.meta.env.DEV) {
      console.warn('[iconRegistry] unknown icon key:', key);
    }
    return null;
  }
  return <Icon size={size} className={className} />;
}
